import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { ACHConversions } from './ach/ACHConversions';
import { CheckConversions } from './checks/CheckConversions';
import { WireConversions } from './wires/WireConversions';
import { InternalTransferConversions } from './internalTransfers/InternalTransferConversions';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const conversions = {
  ACH: ACHConversions,
  Check: CheckConversions,
  Wire: WireConversions,
  'Internal Transfer': InternalTransferConversions,
};
/**
 *
 * There are two things to ask when converting. Can we convert in place (new disbursement) or do we need to make a new one (Saved Disbursement)
 *
 * @param data The data to Convert
 * @param to what we are converting this to
 */
export const convertDisbursementType = (
  data: IDisbursementFormData,
  to: 'Check' | 'Wire' | 'ACH' | 'Internal Transfer',
  order: IOrderDetailsData,
  fee: ICreateSettlementFeeForm,
  isSpruceWithZillowEnabled: boolean,
  isZillowClosing: boolean
): IDisbursementFormData => {
  const conversionToUse = conversions[to]?.[data.type as keyof (typeof conversions)[typeof to]];
  if (conversionToUse) {
    return (conversionToUse as any)(data, order, fee, isSpruceWithZillowEnabled, isZillowClosing);
  }
  return data;
};
